// profiles.store.js
import { action, observable  } from "mobx";

import { axios } from "../../utils/axios";

export default class DebugStore {
    @observable jsonDump = {};
    @observable state = "idle"; // "pending" / "done" / "error"
    @observable errorSource = "";
    @observable errorTitle = "";
    @observable errorDetail = "";
    rootStore;

    constructor(rootStore: any) {
        this.rootStore = rootStore;
    }

    @action
    fetchQuts(
        qutsID: string
    ) {
        let store = this;
        axios()
        .get(
            `/quts/${qutsID}`
        )
        .then(function(res: any) {
            store.jsonDump = res.data;
        })
        .catch(function(err: any) {
            store.state = "error";

            store.errorSource = err.response.data.source;
            store.errorTitle = err.response.data.title;
            store.errorDetail = err.response.data.detail;
        });

    }
}
